import { Routes } from '@angular/router';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

const rootPath = 'relatorios';
export const arrecadacaoRelatorioRoutes: Routes = [
    {
        path: rootPath,
        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/arrecadacao-relatorios-content').then((m) => m.ArrecadacaoRelatoriosContent),
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Relatórios', permission: PERMISSOES.arrecadacao.relatorios.escopo },
        children: [
            { path: '', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-baixa-manual/relatorio-baixa-manual').then((m) => m.RelatorioBaixaManual), data: { breadcrumb: 'Baixa Manual' } },
            { path: 'baixa-manual', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-baixa-manual/relatorio-baixa-manual').then((m) => m.RelatorioBaixaManual), data: { breadcrumb: 'Baixa Manual' } },
            {
                path: 'boletos-emitidos',
                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-boletos-emitidos/relatorio-boletos-emitidos').then((m) => m.RelatorioBoletosEmitidos),
                data: { breadcrumb: 'Boletos Emitidos' }
            },
            {
                path: 'boletos-emitidos-periodo',
                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/boletos-emitidos-periodo/boletos-emitidos-periodo').then((m) => m.BoletosEmitidosPeriodo),
                data: { breadcrumb: 'Boletos Emitidos por Período' }
            },
            {
                path: 'notificacao-cobranca',
                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/notificacao-cobranca/notificacao-cobranca').then((m) => m.NotificacaoCobranca),
                data: { breadcrumb: 'Notificação de Cobrança' }
            },
            {
                path: 'emissao',
                data: { breadcrumb: 'Emissão' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    {
                        path: 'certidao-cadastral',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/emissao/certidao-cadastral/certidao-cadastral').then((m) => m.CertidaoCadastral),
                        data: { breadcrumb: 'Certidão Cadastral' }
                    },
                    {
                        path: 'certidao-negativa-debito',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/emissao/certidao-negativa-debito/certidao-negativa-debito').then((m) => m.CertidaoNegativaDebito),
                        data: { breadcrumb: 'Certidão Negativa de Débito' }
                    },
                    {
                        path: 'certidao-positiva-debito',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/emissao/certidao-positiva-debito/certidao-positiva-debito').then((m) => m.CertidaoPositivaDebito),
                        data: { breadcrumb: 'Certidão Positiva de Débito' }
                    },
                    {
                        path: 'declaracao-valores-pagos',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/emissao/declaracao-valores-pagos/declaracao-valores-pagos').then((m) => m.DeclaracaoValoresPagos),
                        data: { breadcrumb: 'Declaração de Valores Pagos' }
                    },
                    {
                        path: 'ficha-financeira',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/emissao/ficha-financeira/ficha-financeira').then((m) => m.FichaFinanceira),
                        data: { breadcrumb: 'Ficha Financeira' }
                    }
                ]
            },
            {
                path: 'debitos-diferencas-geradas',
                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/debitos-diferencas-geradas/debitos-diferencas-geradas').then((m) => m.DebitosDiferencasGeradas),
                data: { breadcrumb: 'Débitos com Diferenças Geradas' }
            },
            {
                path: 'debitos-gerados',
                data: { breadcrumb: 'Débitos Gerados' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    { path: 'usuario', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/debitos-gerados/usuario/debitos-gerados-usuario').then((m) => m.DebitosGeradosUsuario), data: { breadcrumb: 'Por Usuário' } },
                    {
                        path: 'periodo',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/debitos-gerados/periodo/debitos-gerados-por-periodo').then((m) => m.DebitosGeradosPorPeriodo),
                        data: { breadcrumb: 'Por Período' }
                    }
                ]
            },
            { path: 'extrato-mensal', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/extrato-mensal/extrato-mensal').then((m) => m.ExtratoMensal), data: { breadcrumb: 'Extrato Mensal' } },
            { path: 'cartao', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/cartao/cartao').then((m) => m.Cartao), data: { breadcrumb: 'Cartão' } },
            { path: 'relatorio-isencao', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-isencao/relatorio-isencao').then((m) => m.RelatorioIsencao), data: { breadcrumb: 'Relatório de Isenção' } },
            {
                path: 'recebimento',
                data: { breadcrumb: 'Recebimento' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    {
                        path: 'recebimento-cartao-banco',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/recebimento-cartao-banco/recebimento-cartao-banco').then((m) => m.RecebimentoCartaoBanco),
                        data: { breadcrumb: 'Recebimento Cartão Banco' }
                    },
                    { path: 'recebimento-mes', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/recebimento-mes/recebimento-mes').then((m) => m.RecebimentoMes), data: { breadcrumb: 'Recebimento por Mês' } }
                ]
            },
            { path: 'recebimento-cartao-banco', pathMatch: 'full', redirectTo: 'recebimento/recebimento-cartao-banco' },
            { path: 'recebimento-mes', pathMatch: 'full', redirectTo: 'recebimento/recebimento-mes' },
            {
                path: 'retornos',
                data: { breadcrumb: 'Retornos' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    { path: 'processados', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/retornos/processados/retornos-processados').then((m) => m.RetornosProcessados), data: { breadcrumb: 'Processados' } },
                    { path: 'retornos-recusados', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/retornos/recusados/retornos-recusados').then((m) => m.RetornosRecusados), data: { breadcrumb: 'Recusados' } }
                ]
            },
            {
                path: 'faixa-capital-social',
                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/faixa-capital-social/faixa-capital-social').then((m) => m.FaixaCapitalSocial),
                data: { breadcrumb: 'Faixa de Capital Social' }
            },
            { path: 'repasse-cota-parte', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/repasse-cota-parte/repasse-cota-parte').then((m) => m.RepasseCotaParte), data: { breadcrumb: 'Repasse Cota Parte' } },
            { path: 'parcelamento', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-parcelamento/relatorio-parcelamento').then((m) => m.RelatorioParcelamento), data: { breadcrumb: 'Parcelamento' } },
            {
                path: 'inadimplentes',
                data: { breadcrumb: 'Inadimplentes' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    {
                        path: 'analitico',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/inadimplentes/analitico/relatorio-inadimplentes-analitico').then((m) => m.RelatorioInadimplentesAnalitico),
                        data: { breadcrumb: 'Analítico' }
                    },
                    {
                        path: 'sintetico',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/inadimplentes/sintetico/relatorio-inadimplentes-sintetico').then((m) => m.RelatorioInadimplentesSintetico),
                        data: { breadcrumb: 'Sintético' }
                    },
                    {
                        path: 'pessoa-juridica',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/inadimplentes/pessoa-juridica/relatorio-inadimplente-pj').then((m) => m.RelatorioInadimplentePj),
                        data: { breadcrumb: 'Pessoa Jurídica' }
                    }
                ]
            },
            { path: 'relatorio-contabil', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-contabil/relatorio-contabil').then((m) => m.RelatorioContabil), data: { breadcrumb: 'Relatório Contábil' } },
            { path: 'relatorio-credito', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/relatorio-credito/relatorio-credito').then((m) => m.RelatorioCredito), data: { breadcrumb: 'Relatório de Crédito' } },
            {
                path: 'debitos-com-diferenca',
                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/debitos-com-diferenca/debitos-com-diferenca').then((m) => m.DebitosComDiferenca),
                data: { breadcrumb: 'Débitos com Diferença' }
            },
            {
                path: 'negociacao',
                data: { breadcrumb: 'Negociação' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    {
                        path: 'relacao-negociacao',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/negociacao/relacao-negociacao/negociacao-relacao-negociacao').then((m) => m.NegociacaoRelacaoNegociacao),
                        data: { breadcrumb: 'Relação de Negociação' }
                    },
                    {
                        path: 'negociacao-em-dia',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/negociacao/negociacao-em-dia/negociacao-em-dia').then((m) => m.NegociacaoEmDia),
                        data: { breadcrumb: 'Negociação em Dia' }
                    }
                ]
            },
            {
                path: 'desconto-medico-empresa',
                data: { breadcrumb: 'Desconto Médico Empresa' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    {
                        path: 'aptos-ao-desconto',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/desconto-medico-empresa/aptos-ao-desconto/aptos-ao-desconto').then((m) => m.AptosAoDesconto),
                        data: { breadcrumb: 'Aptos ao Desconto' }
                    },
                    {
                        path: 'pedidos-de-desconto',
                        loadComponent: () =>
                            import('@/features/financeiro/arrecadacao/relatorios/components/desconto-medico-empresa/pedidos-de-desconto/desconto-medico-empresa-pedidos-de-desconto').then((m) => m.DescontoMedicoEmpresaPedidosDeDesconto),
                        data: { breadcrumb: 'Pedidos de Desconto' }
                    },
                    {
                        path: 'situacao-das-empresas',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/desconto-medico-empresa/situacao-das-empresas/situacao-das-empresas').then((m) => m.SituacaoDasEmpresas),
                        data: { breadcrumb: 'Situação das Empresas' }
                    }
                ]
            },
            {
                path: 'listagem-valor',
                data: { breadcrumb: 'Listagem de Valores' },
                children: [
                    { path: '', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty) },
                    {
                        path: 'a-receber',
                        data: { breadcrumb: 'A Receber' },
                        children: [
                            {
                                path: 'selecao',
                                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/a-receber/relatorio-selecao/relatorio-selecao').then((m) => m.RelatorioSelecao),
                                data: { breadcrumb: 'Seleção' }
                            },
                            {
                                path: 'total-por-anuidades',
                                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/a-receber/total-por-anuidades/total-por-anuidades').then((m) => m.TotalPorAnuidades),
                                data: { breadcrumb: 'Total por Anuidades' }
                            },
                            {
                                path: 'valores-a-receber',
                                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/a-receber/valores-a-receber/valores-a-receber').then((m) => m.ValoresAReceber),
                                data: { breadcrumb: 'Valores a Receber' }
                            }
                            // { path: '', pathMatch: 'full', redirectTo: 'selecao' }
                        ]
                    },
                    {
                        path: 'recebidos',
                        data: { breadcrumb: 'Recebidos' },
                        children: [
                            {
                                path: 'boleto',
                                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/recebidos/relatorio-boleto/relatorio-boleto').then((m) => m.RelatorioBoleto),
                                data: { breadcrumb: 'Boleto' }
                            },
                            {
                                path: 'cartao',
                                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/recebidos/relatorio-cartao/relatorio-cartao').then((m) => m.RelatorioCartao),
                                data: { breadcrumb: 'Cartão' }
                            },
                            { path: 'pix', loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/recebidos/relatorio-pix/relatorio-pix').then((m) => m.RelatorioPix), data: { breadcrumb: 'Pix' } },
                            {
                                path: 'divida-ativa',
                                loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/recebidos/relatorio-divida-ativa/relatorio-divida-ativa').then((m) => m.RelatorioDividaAtiva),
                                data: { breadcrumb: 'Dívida Ativa' }
                            }
                        ]
                    },
                    {
                        path: 'debitos-com-diferenca',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/listagem-valor/debitos-com-diferenca/debitos-com-diferenca').then((m) => m.DebitosComDiferenca),
                        data: { breadcrumb: 'Débitos com Diferença' }
                    },
                    {
                        path: 'favorecidos-pelo-refis',
                        loadComponent: () => import('@/features/financeiro/arrecadacao/relatorios/components/favorecidos-pelo-refis/favorecidos-pelo-refis').then((m) => m.FavorecidosPeloRefis),
                        data: { breadcrumb: 'Favorecidos pelo Refis' }
                    }
                ]
            }
        ]
    }
];
